import TranslatorService from "../../../services/Translator/TranslatorService";

const Select = ({ id, ariaLabel, value, onChange, options, icon }) => {
    return (
      <select
        className="form-select select-aira"
        id={id}
        aria-label={ariaLabel}
        value={value}
        onChange={onChange}
      >
        {icon && 
          <label className="input-group-text" for="" style={{ color: "white", backgroundColor:"white"}}>{icon}teste</label>
        }
        {/* Renderiza uma opção padrão, se necessário */}
        <option value="" disabled>
          <TranslatorService path="chatForms.selectDefault" />
        </option>
        {/* Mapeia as opções para criar elementos <option> */}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
};
  
export default Select;